// Značka asistenta (dvě jiskry) — v poli hledání, v panelu asistenta a u tlačítka poradce zařazení odpadu.
export function ZnackaAsistenta({ velikost = 17 }: { velikost?: number }) {
  return (
    <svg width={velikost} height={velikost} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 2.5l1.9 5.6L19.5 10l-5.6 1.9L12 17.5l-1.9-5.6L4.5 10l5.6-1.9z"
        fill="currentColor"
      />
      <path
        d="M18.5 15l.9 2.6 2.6.9-2.6.9-.9 2.6-.9-2.6-2.6-.9 2.6-.9z"
        fill="currentColor"
        opacity=".65"
      />
    </svg>
  );
}
